/** Tariff type stored by the backend (`business.tariffType`). */
export enum TariffType {
  STANDARD = 'STANDARD',
  PERSONALIZED = 'PERSONALIZED',
  MANUAL = 'MANUAL',
}

export enum TariffRateType {
  MINIMUM = 'MINIMUM',
  SUGGESTED = 'SUGGESTED',
}
